import moment from 'moment';

export const getDateRanges = () => {
  const now = moment();

  const today = now.format('MM/DD/YYYY');

  const yesterday = () => moment().subtract(1, 'd');
  const last30Days = () => moment().subtract(30, 'd');
  const last60Days = () => moment().subtract(60, 'd');
  const last90Days = () => moment().subtract(90, 'd');
  const last180Days = () => moment().subtract(180, 'd');
  const last365Days = () => moment().subtract(365, 'd');

  const beginThisMonth = () => moment().startOf('month');
  const beginThisYear = () => moment().startOf('year');
  const beginMonth = () => moment().subtract(1, 'M').startOf('month');
  const endMonth = () => moment().subtract(1, 'M').endOf('month');

  const lastWeekBegin = () => moment().subtract(1, 'W').startOf('week');
  const lastWeekEnd = () => moment().subtract(1, 'W').endOf('week');
  const lastMonthBegin = () => moment().subtract(1, 'M').startOf('month');
  const lastMonthEnd = () => moment().subtract(1, 'M').endOf('month');
  const lastQuarterBegin = () => moment().subtract(1, 'Q').startOf('quarter');
  const lastQuarterEnd = () => moment().subtract(1, 'Q').endOf('quarter');
  const lastYearBegin = () => moment().subtract(1, 'Y').startOf('year');
  const lastYearEnd = () => moment().subtract(1, 'Y').endOf('year');

  return {
    today: { dateFrom: today, dateTo: today },
    monthToDate: { dateFrom: beginThisMonth().format('MM/DD/YYYY'), dateTo: now.format('MM/DD/YYYY') },
    yearToDate: { dateFrom: beginThisYear().format('MM/DD/YYYY'), dateTo: now.format('MM/DD/YYYY') },
    yesterday: { dateFrom: yesterday().format('MM/DD/YYYY'), dateTo: yesterday().format('MM/DD/YYYY') },
    month: { dateFrom: beginMonth().format('MM/DD/YYYY'), dateTo: endMonth().format('MM/DD/YYYY') },
    lastWeek: { dateFrom: lastWeekBegin().format('MM/DD/YYYY'), dateTo: lastWeekEnd().format('MM/DD/YYYY') },
    lastMonth: { dateFrom: lastMonthBegin().format('MM/DD/YYYY'), dateTo: lastMonthEnd().format('MM/DD/YYYY') },
    lastQuarter: { dateFrom: lastQuarterBegin().format('MM/DD/YYYY'), dateTo: lastQuarterEnd().format('MM/DD/YYYY') },
    lastYear: { dateFrom: lastYearBegin().format('MM/DD/YYYY'), dateTo: lastYearEnd().format('MM/DD/YYYY') },
    last30Days: { dateFrom: last30Days().format('MM/DD/YYYY'), dateTo: today },
    last60Days: { dateFrom: last60Days().format('MM/DD/YYYY'), dateTo: today },
    last90Days: { dateFrom: last90Days().format('MM/DD/YYYY'), dateTo: today },
    last180Days: { dateFrom: last180Days().format('MM/DD/YYYY'), dateTo: today },
    last365Days: { dateFrom: last365Days().format('MM/DD/YYYY'), dateTo: today }
  };
};

export const getRangeDate = () => {
  const yesterday = () => moment().subtract(1, 'd');
  const monthToDate = () => moment().startOf('month');
  const yearToDate = () => moment().startOf('year');
  const lastWeek = () => moment().subtract(1, 'W').startOf('week');
  const lastMonth = () => moment().subtract(1, 'M').startOf('month');
  const lastQuarter = () => moment().subtract(1, 'Q').startOf('quarter');
  const lastYear = () => moment().subtract(1, 'Y').startOf('year');

  return {
    today: moment().format('MM-DD-YYYY'),
    yesterday: yesterday().format('MM-DD-YYYY'),
    month: monthToDate().format('MM-DD-YYYY'),
    year: yearToDate().format('MM-DD-YYYY'),
    lastWeek: lastWeek().format('MM-DD-YYYY'),
    lastMonth: lastMonth().format('MM-DD-YYYY'),
    lastQuarter: lastQuarter().format('MM-DD-YYYY'),
    lastYear: lastYear().format('MM-DD-YYYY')
  };
};
